import React, { useEffect, useState } from "react";
import "../App.css";
import { Routes, Route } from "react-router-dom";

import Dashboard from "../AdminPages/dashboard/dashboard";
import AdmissionData from "../AdminPages/admission/admissionData";
import AdmissionDetails from "../AdminPages/admission/admission-details";
import AddStudent from "../AdminPages/student/addStudent";
import AddSchool from "../AdminPages/school/addSchool";
import AddCourse from "../AdminPages/school/addCourse";
import AddAlumni from "../AdminPages/alumni/addAlumni";
import AddNotice from "../AdminPages/eventsAndNotice/addNotice";
import AddEvent from "../AdminPages/eventsAndNotice/addEvent";
import CareerAdmin from "../AdminPages/career/career";
import AddFacalty from "../AdminPages/school/addFaculty";
import DashBoardUpdates from "../AdminPages/dashboard";
import Publication from "../AdminPages/publication";
import HiringCv from "../AdminPages/career/HiringCv";
import Achievement from "../AdminPages/achievment/submit";
import UsersList from "../AdminPages/users/list";

import Recruiter from "../AdminPages/placement/recruiter";
import AddBlogs from "../AdminPages/blogs/addBlogs";
import PublicBlogs from "../AdminPages/blogs/publicBlogs";
import AlumniRequest from "../AdminPages/alumni/alumniRequest";
import RaggingPage from "../AdminPages/ragging/raggingPage";
import BrochureData from "../AdminPages/admission/brochure";
import { SchoolContex } from "../Helper/Contex";
import api from "../API/api";
import Gallery from "../AdminPages/Gallery";

const AdminInterface = () => {
  const [schools, setSchools] = useState();
  const [userType, setUserType] = useState(
    JSON.parse(sessionStorage.getItem("user"))
  );

  useEffect(() => {
    getSchools();
    // setUserType()
  }, []);

  const getSchools = () => {
    api
      .getSchools()
      .then((res) => {
        setSchools(res.data.schools);
      })
      .catch((err) => {
        console.log(err.response);
      });
  };

  // console.log(JSON.parse(sessionStorage.getItem('user')), 'check vals');

  return (
    <>
      <SchoolContex.Provider value={{ schools }}>
        <Routes>
          {/* <Route path='/admin' element={<Dashboard />} /> */}
          <Route path="/admin" element={<Dashboard />} />
        </Routes>

        <Routes>
          {userType?.user_type === 1 ? (
            <Route path="/admin" element={<Dashboard />}>
              <Route path="AdmissionData" element={<AdmissionData />} />
              <Route path="BrochureData" element={<BrochureData />} />
              <Route path="addStudent" element={<AddStudent />} />
              <Route path="addSchool" element={<AddSchool />} />
              <Route path="AddCourse/:s_id" element={<AddCourse />} />
              <Route path="AddFacalty/:s_id" element={<AddFacalty />} />
              <Route path="addAlumni" element={<AddAlumni />} />
              <Route path="AlumniRequest" element={<AlumniRequest />} />
              <Route path="addNotice" element={<AddNotice />} />
              <Route path="addEvent" element={<AddEvent />} />
              <Route path="recruiter" element={<Recruiter />} />
              <Route path="addBlogs" element={<AddBlogs />} />
              <Route path="PublicBlogs" element={<PublicBlogs />} />
              <Route path="career" element={<CareerAdmin />} />
              <Route path="DashBoardUpdates" element={<DashBoardUpdates />} />
              <Route path="Publication" element={<Publication />} />
              <Route path="HiringCv" element={<HiringCv />} />
              <Route path="RaggingPage" element={<RaggingPage />} />
              <Route path="Achievement" element={<Achievement />} />
              <Route path="UsersList" element={<UsersList />} />
              <Route path="AdmissionDetails" element={<AdmissionDetails />} />
              <Route path="gallery" element={<Gallery />} />
            </Route>
          ) : userType?.user_type === 2 ? (
            <Route path="/admin" element={<Dashboard />}>
              <Route path="DashBoardUpdates" element={<DashBoardUpdates />} />
              <Route path="AdmissionData" element={<AdmissionData />} />
            </Route>
          ) : (
            <Route path="/admin" element={<Dashboard />}>
              <Route path="UsersList" element={<UsersList />} />
              <Route path="DashBoardUpdates" element={<DashBoardUpdates />} />
            </Route>
          )}
        </Routes>
      </SchoolContex.Provider>
    </>
  );
};

export default AdminInterface;
